import React, { FC } from 'react';

import { DarkSkeleton } from '@eika/skeleton';

const AccountViewHeaderSkeleton: FC = () => {
    return (
        <div className="account-header__wrapper">
            <dl className="sgw-account-details__meta skeleton">
                <dd className="account-header__owners" />
                <dd className="account-details__name">
                    <h1 className="light">
                        <DarkSkeleton width={200} />
                    </h1>
                </dd>
                <dd className="account-details__accountId">
                    <DarkSkeleton width={100} height={18} />
                </dd>
            </dl>
        </div>
    );
};

export default AccountViewHeaderSkeleton;
